import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const withMultiInputPropsOnChangeHOCGenerator = (Component) => {
  function WithMultiInputPropsOnChangeHOC(props) {
    const { values, validateOnChange } = props;

    useEffect(() => {
      validateOnChange();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values]);

    return <Component {...props} />;
  }

  WithMultiInputPropsOnChangeHOC.propTypes = {
    values: PropTypes.array,
    validateOnChange: PropTypes.func,
  };

  return WithMultiInputPropsOnChangeHOC;
};

const withMultiInputPropsOnChange = () => (Component) => withMultiInputPropsOnChangeHOCGenerator(Component);

export default withMultiInputPropsOnChange;
